/* import __COLOCATED_TEMPLATE__ from './visibility-permissions.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type HelpCenterSite from 'embercom/models/help-center-site';
// @ts-ignore
import { copy } from 'ember-copy';

interface Args {
  ruleset?: $TSFixMe;
  selectedHelpCenter: HelpCenterSite;
}

interface Signature {
  Args: Args;
}

export default class TicketsPortalVisibilityPermissions extends Component<Signature> {
  @service declare intl: IntlService;

  @tracked usersSideSheetVisible = false;

  get isToggleEnabled() {
    return this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets;
  }

  get isFetchingRulesetAudience() {
    return this.args.ruleset?.fetchAudiencePreviewTask.isRunning ?? false;
  }

  @action
  toggleRestrictToUserTickets() {
    this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets =
      !this.args.selectedHelpCenter.ticketsPortalRestrictToUserTickets;
  }

  @action
  onUpdatePredicates(predicates: $TSFixMe) {
    this.args.ruleset.set('predicateGroup.predicates', copy(predicates));
    this.args.ruleset.get('fetchAudiencePreviewTask').perform();
  }

  @action
  onUpdateRolePredicates(rolePredicates: $TSFixMe) {
    this.args.ruleset.set('rolePredicateGroup.predicates', copy(rolePredicates));
    this.args.ruleset.get('fetchAudiencePreviewTask').perform();
  }

  @action
  toggleUsersSideSheet() {
    this.usersSideSheetVisible = !this.usersSideSheetVisible;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::Tickets::TicketsPortal::VisibilityPermissions': typeof TicketsPortalVisibilityPermissions;
    'new-settings/helpdesk/tickets/tickets-portal/visibility-permissions': typeof TicketsPortalVisibilityPermissions;
  }
}
